import PropTypes from 'prop-types';
import Entity from '../../entity/Entity';


/**
 *
 * @param root0
 * @param root0.before
 * @param root0.after
 * @param root0.from
 * @param root0.to
 * @param root0.onChangeTime
 * @param root0.fromHour
 * @param root0.toHour
 * @param root0.allowRangeSelection
 * @returns {JSX} DatePickedOrInfinityRange
 */
function DatePickedOrInfinityRange({ before, after, from, to, onChangeTime, fromHour, toHour, allowRangeSelection }) {
    return (
        <div>
            <div className='flex justify-between gap-2 items-center'>
                {
                    before && <Entity entity='date_picker.before_time' className='text-sm' data={{ to: to?.toLocaleString() }} />
                }
                {
                    after && <Entity entity='date_picker.after_time' className='text-sm' data={{ from: from?.toLocaleString() }} />
                }
                {
                    !before && !after && <Entity entity='date_picker.select_time' className='text-sm' />
                }
                <input
                    type='time'
                    name={after || !allowRangeSelection ? 'fromHour' : 'toHour'}
                    value={after || !allowRangeSelection ? fromHour : toHour}
                    min={'00:00'}
                    max={'23:59'}
                    onChange={onChangeTime}
                    pattern='((0\d|1\d)|(2[0-3])):([0-5]\d)'
                    autoComplete='off'
                />
            </div>
        </div>
    );
}

DatePickedOrInfinityRange.propTypes = {
    before: PropTypes.bool,
    after: PropTypes.bool,
    from: PropTypes.object,
    to: PropTypes.object,
    onChangeTime: PropTypes.func,
    fromHour: PropTypes.string,
    toHour: PropTypes.string,
    allowRangeSelection: PropTypes.bool
};

export default DatePickedOrInfinityRange;